import http from './httpService';

const getCalendarReports = (code) => http.get(`api/planning/getGlobalRecords/${code}/LAUNCH_REPORT`);

export default {
    getCalendarReports,
};
